import React, { useCallback, useState } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useField } from 'formik';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import PropTypes from 'prop-types';
import DEFAULT_FILLED_INPUT_CLASS_NAME from '../../theme/constants/filled-input';
import { DEFAULT_ICON_BUTTON_CLASS_NAME } from '../../theme/constants/icon-button';

const PasswordField = ({ InputProps, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [field, meta] = useField('password');

  const toggleShowPassword = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);
  return (
    <TextField
      {...field}
      name="password"
      type={showPassword ? 'text' : 'password'}
      variant="filled"
      fullWidth
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : undefined}
      InputProps={{
        ...InputProps,
        className: InputProps?.className || DEFAULT_FILLED_INPUT_CLASS_NAME,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={toggleShowPassword}
              className={DEFAULT_ICON_BUTTON_CLASS_NAME}
              edge="end"
            >
              {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  );
};

export default PasswordField;

PasswordField.propTypes = {
  InputProps: PropTypes.shape({
    className: PropTypes.string,
  }),
};

PasswordField.defaultProps = {
  InputProps: {},
};
